<template>
  <CommonLoading v-if="loading" />
  
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-2xl sm:p-6">
              
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Editar Agendamento (Coordenador)</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div class="mt-4">
                <form class="flex flex-col gap-4" @submit="sendData" method="POST">
                  
                  <!-- Consultor -->
                  <div>
                    <label for="consultor_email" class="block text-sm font-medium text-gray-900">Consultor</label>
                    <select
                      v-model="data.consultor_email"
                      id="consultor_email"
                      name="consultor_email"
                      required
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    >
                      <option value="" disabled>Selecione um consultor</option>
                      <option
                        v-for="consultor in consultores"
                        :key="consultor.email"
                        :value="consultor.email"
                      >
                        {{ consultor.name }}
                      </option>
                    </select>
                  </div>

                  <!-- Data Visita -->
                  <div>
                    <label for="data_visita" class="block text-sm font-medium leading-6 text-gray-900">Data da visita</label>
                    <input
                      v-model="data.data_visita"
                      id="data_visita"
                      name="data_visita"
                      type="datetime-local"
                      required
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    />
                  </div>
                  <div class="mt-6 border-t border-gray-200 pt-4">
                    <h3 class="text-sm font-medium leading-6 text-gray-900 mb-2">Observações</h3>
                    <div v-if="placeHolderValues.observacoes && placeHolderValues.observacoes.length > 0" class="space-y-3 max-h-40 overflow-y-auto pr-2">
                      <div v-for="obs in placeHolderValues.observacoes" :key="obs.id" class="bg-gray-50 rounded-md p-3 text-sm text-gray-700">
                        <div class="flex justify-between items-center mb-1">
                          <span class="font-semibold">{{ obs.autor_email }}</span>
                          <span class="text-xs text-gray-500">{{ new Date(obs.created_at).toLocaleString() }}</span>
                        </div>
                        <p>{{ obs.descricao }}</p>
                      </div>
                    </div>
                    <div v-else class="text-sm text-gray-500 italic">
                      Nenhuma observação registrada.
                    </div>
                  </div>

                  <div class="mt-4 border-t border-gray-200 pt-4">
                    <h3 class="text-sm font-medium leading-6 text-gray-900 mb-2">Timeline</h3>
                    <div v-if="placeHolderValues.timeline && placeHolderValues.timeline.length > 0" class="space-y-3 max-h-40 overflow-y-auto pr-2">
                      <div v-for="evento in placeHolderValues.timeline" :key="evento.id" class="border-l-2 border-indigo-500 pl-3 py-1">
                        <div class="flex justify-between items-center">
                          <span class="text-sm font-semibold text-gray-900">{{ evento.titulo }}</span>
                          <span class="text-xs text-gray-500">{{ new Date(evento.created_at).toLocaleString() }} - {{ evento.autor_email }}</span>
                        </div>
                        <p class="text-sm text-gray-700 mt-1" v-if="evento.descricao">{{ evento.descricao }}</p>
                      </div>
                    </div>
                    <div v-else class="text-sm text-gray-500 italic">
                      Nenhum evento registrado na timeline.
                    </div>
                  </div>
                  
                  <div class="mt-6 flex justify-end border-t border-gray-200 pt-4">
                    <button type="button" @click="closeDialog" class="mr-3 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                      Cancelar
                    </button>
                    <button type="submit" class="inline-flex justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">
                      Salvar Alterações
                    </button>
                  </div>

                </form>
              </div>

            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';

export default {
  name: 'TodasVisitasForm',
  emits: ['update-open', 'editing-data'],
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    CommonLoading
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    placeHolderValues: {
      type: Object,
      required: true
    },
    consultores: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      data: {
        consultor_email: '',
        data_visita: ''
      },
      loading: false,
    };
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      // Usando os dados da lista de agendamentos associada à ficha
      this.data = { 
        consultor_email: this.placeHolderValues.consultor_email || '',
        data_visita: this.placeHolderValues.data_visita ? this.formatDateForInput(this.placeHolderValues.data_visita) : ''
      };
    },

    formatDateForInput(dateString) {
      if (!dateString) return '';
      // Trata possíveis formatos para input datetime-local (YYYY-MM-DDTHH:mm)
      try {
          const date = new Date(dateString);
          if(isNaN(date.getTime())) return dateString; // Caso o string já esteja no formato certo

          const pad = (n) => (n < 10 ? '0' + n : n);
          return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
      } catch (e) {
          return dateString;
      }
    },

    sendData(e) {
      e.preventDefault();
      // Envia os dados para salvar na Lista de Agendamentos correspondente!
      this.$emit('editing-data', this.data, this.placeHolderValues.id);
    },

    closeDialog() {
      this.$emit('update-open', false);
    }
  }
}
</script>
